import React, {useRef, useState, useEffect, useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {Button} from "react-bootstrap";
import {Input, MessageList} from "react-chat-elements";
import {ReactComponent as Send} from "../../icons/send.svg";
import {checkInvoiceStatusAction} from "../../store/actions/OrdersActions";
import {useTranslation} from "react-i18next";
import {ReactComponent as ApplePay} from "../../images/ApplePay.svg";
import {ReactComponent as GooglePay} from "../../images/GooglePay.svg";
import {ReactComponent as Phone} from "../../icons/phone.svg";
import {translateRecord} from "./utils";

const OrderChat = (props) => {
  const storeAuth = useSelector(store => store.auth);
  const [state, setState] = useState({
    message: ''
  });
  const inputRef = useRef();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const modalBodyRef = useRef(null);

  useEffect(() => {
    scrollToBottom()
  }, []);


  function scrollToBottom() {
    if (modalBodyRef.current) {
      modalBodyRef.current.scrollTop = modalBodyRef.current.scrollHeight;
    }
  }

  function handleKeyDown(key) {
    if (key === 'Enter') {
      handleSendMessage();
      inputRef.current.value = '';
    } else if (!!props.onMessageType) {
      props.onMessageType();
    }
  }

  function handleMessageChange(value) {
    setState({...state, message: value})
  }

  function handleSendMessage() {
    inputRef.current.value = '';
    handleMessageChange('');
    props.sendMessage(state.message);
  }

  function messageTime(message) {
    const mDate = new Date(message.time);
    const minutes = mDate.getMinutes();
    const hours = mDate.getHours();
    return `${hours}:${minutes < 10 ? `0${minutes}` : minutes}`
  }

  function handlePay() {
    dispatch(checkInvoiceStatusAction(props.orderToPay.id));
  }

  return (
    <div>
      { Object.keys(props.messages).length > 0 &&
        <MessageList
          className='message-list'
          toBottomHeight={'100%'}
          lockable={true}
          referance={modalBodyRef}
          dataSource={ Object.values(props.messages).map((message) => {
            return (
              { position: message.user_id === storeAuth.auth.userData.id ? 'right' : 'left',
                type: 'text',
                text: message.text,
                date: new Date(message.time),
                dateString: messageTime(message),
                title: message.user_name,
                status: (message.user_id === storeAuth.auth.userData.id) && message.seen ? 'read' : null
              }
            )
          })}
        />}
      { !!props.orderToPay ?
        <>
          { props.orderToPay.shared ?
            <Button className="btn-success btn-block make-order make-order-checkout" style={{bottom: 0}}
                    onClick={() => window.location.href = `/orders/${props.orderToPay.id}`}
            >
              <h4 className='text-black mb-0'>{t('components.menu.toOrder')}</h4>
            </Button>
          :
            <Button className="btn-success btn-block make-order make-order-checkout" onClick={handlePay}
                    style={{bottom: 0}}
            >
              <h4 className='text-black mb-0'>{t('pay')}</h4>
              <ApplePay style={{height: '30px', width: '70px'}}/>
              <GooglePay fill='white' style={{height: '30px', width: '70px'}}/>
            </Button>}
        </>
      :
        <Input placeholder={`${!!props.restaurant ? translateRecord(props.restaurant, 'name')+'.' : ''} ${t('writeMessage')}`}
               className='reply-order-message'
               referance={inputRef}
               multiline={true}
               maxHeight={100}
               onFocus={!!props.onMessageType && props.onMessageType}
               onBlur={!!props.onMessageType && props.onMessageType}
               onKeyDown={(e) => handleKeyDown(e.key)}
               onChange={(e) => handleMessageChange(e.target.value)}
               leftButtons={!!props.restaurant &&
                 <a className='btn btn-primary' href={`tel:+${props.restaurant.phone}`}>
                   <Phone/>
                 </a>}
               rightButtons={<Button onClick={() => handleSendMessage()}><Send width={20} height={20}/></Button>}
        />}
    </div>
  );
};

export default OrderChat;